export default __webpack_public_path__ + "static/media/flag-liechtenstein.166e942c.svg";